/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S1_IntroInputs */

const tr_mesafeli_s1_intro = /** @type {(inputs: Mesafeli_S1_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu Mesafeli Hizmet Sözleşmesi ("Sözleşme") bir tarafta:`)
};

const en_mesafeli_s1_intro = /** @type {(inputs: Mesafeli_S1_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Distance Service Agreement ("Agreement") is concluded, on the one side, by:`)
};

const de_mesafeli_s1_intro = /** @type {(inputs: Mesafeli_S1_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Fernabsatz-Dienstleistungsvertrag ("Vertrag") wird auf der einen Seite geschlossen von:`)
};

const ru_mesafeli_s1_intro = /** @type {(inputs: Mesafeli_S1_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настоящий Договор дистанционного оказания услуг («Договор») заключается, с одной стороны:`)
};

/**
* | output |
* | --- |
* | "This Distance Service Agreement (\"Agreement\") is concluded, on the one side, by:" |
*
* @param {Mesafeli_S1_IntroInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s1_intro = /** @type {((inputs?: Mesafeli_S1_IntroInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S1_IntroInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s1_intro(inputs)
	if (locale === "de") return de_mesafeli_s1_intro(inputs)
	if (locale === "ru") return ru_mesafeli_s1_intro(inputs)
	return tr_mesafeli_s1_intro(inputs)
});